<template>
  <div
    class="splash-container"
    role="status"
    aria-live="polite"
  >
    <div class="splash-content">
      <img
        :src="scLogoImg"
        alt="Slick Cactus"
        class="splash-logo"
      >
      <!-- two squares chasing round a 2x2 grid; the goo filter melts them together where they meet -->
      <div class="splash-loader" aria-hidden="true">
        <svg class="splash-loader__defs" width="0" height="0">
          <filter id="splash-goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="3" />
            <feColorMatrix values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" />
          </filter>
        </svg>
        <span class="splash-loader__square" />
        <span class="splash-loader__square splash-loader__square--trailing" />
      </div>
      <span class="d-sr-only">Loading</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import scLogoImg from '@/assets/img/sc-logo.png';
</script>

<style scoped>
.splash-container {
  position: fixed;
  inset: 0;
  z-index: 999999;
  /* the page ground (#fff in light): a white splash flashed on every dark load */
  background-color: rgb(var(--v-theme-background));
  display: flex;
  align-items: center;
  justify-content: center;
}

.splash-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.splash-logo {
  width: 112px;
  height: auto;
  animation: splash-fade-in 0.5s ease-out both;
}

/* the logo's green; the loader shows after a beat so a quick load never flashes it */
.splash-loader {
  width: 56px;
  aspect-ratio: 1;
  padding: 4px;
  box-sizing: border-box;
  display: grid;
  /* under the cactus stem, not the image centre: the stem sits at 74.5 of the logo's 176px
     (the right arm is the longer one), 8.5px left of centre at 112px wide */
  translate: calc(112px * (74.5 - 88) / 176) 0;
  filter: url('#splash-goo');
  animation: splash-fade-in 0.3s ease-out 0.4s both;
}

.splash-loader__defs {
  position: absolute;
}

.splash-loader__square {
  grid-area: 1 / 1;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: #6cc04a;
  animation: splash-loader-chase 2s ease-in-out infinite;
}

.splash-loader__square--trailing {
  animation-delay: -1s;
}

@keyframes splash-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes splash-loader-chase {
  0%,
  100% {
    transform: translate(0, 0);
  }

  25% {
    transform: translate(100%, 0);
  }

  50% {
    transform: translate(100%, 100%);
  }

  75% {
    transform: translate(0, 100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .splash-logo {
    animation: none;
  }

  .splash-loader__square {
    animation: splash-loader-pulse 1.6s ease-in-out infinite alternate;
  }

  .splash-loader__square--trailing {
    transform: translate(100%, 100%);
  }

  @keyframes splash-loader-pulse {
    from {
      opacity: 0.35;
    }

    to {
      opacity: 1;
    }
  }
}
</style>
